// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MainNavigation__tab{min-height:56px}.MainNavigation__navTabs{margin-left:56px}\n", ""]);
// Exports
exports.locals = {
	"tab": "MainNavigation__tab",
	"navTabs": "MainNavigation__navTabs"
};
module.exports = exports;
